import React from 'react';
import { SocItemModel } from '../../../domain/SocItem';
import { InternalMessageDialog } from "./dialog/InternalMessageDialog";
import { DialogType, EntityDialog } from './types';
import { CaseNoteDialog } from './dialog/CaseNoteDialog';
import { SendMessageDialog } from "./dialog/SendMessageDialog";
import { AddEventDialog } from "../dialog/AddEventDialog";
import { RecordEventCompletionDialog } from "../dialog/RecordEventCompletionDialog";

type RenderDialogProps = {
  focussedEntity: EntityDialog | null;
  onClose: () => void;
  soc: SocItemModel;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focussedEntity,
  onClose,
  soc,
}) => {
  if (!focussedEntity) return null;

  const { dialogType } = focussedEntity;
  const activity = focussedEntity.focussedActivity!;

  switch (dialogType) {
    case DialogType.SendMessage:
      return <SendMessageDialog onClose={onClose} resource={soc} />;
    case DialogType.AddEvent:
        return <AddEventDialog onClose={onClose} resource={soc} />;
      case DialogType.CompleteEvent:
        return (
          <RecordEventCompletionDialog
            onClose={onClose}
            resource={soc}
            activity={activity}
          />
        );
    case DialogType.InternalMessage:
      return <InternalMessageDialog onClose={onClose} resource={soc} />;
    case DialogType.CaseNote:
      return <CaseNoteDialog onClose={onClose} resource={soc} />;
    default:
      return null;
  }
};
